<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
   
  .paused > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;}
  
  }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 612.9 500.1">
<g class:paused={isPaused} class:flip={flipsvg}>
    <g id="crossbody" bind:this={rootElement}>
      <path
        fill="var(--flesh)"
        d="M172 365c-9 13-18 25-31 35a23 23 0 0 0-6 8c-2 4-6 6-9 8-17 13-36 23-54 34l-5 2c-11 2-13 11-14 19 0 4-1 7-4 9a3 3 0 0 0-1 3c2 8 1 11-7 13v1c-7-1-15 4-22 0l-2 1c-5 1-7-1-7-5 0-3-1-4-3-4-4 0-6-2-7-5v-4c3-5 4-11 8-16a35 35 0 0 0 8-8l60-47a30 30 0 0 0 6-7c8-12 20-20 31-28l9-6a16 16 0 0 0 6-6l14-16 1 1c10-4 18-1 26 5 6 5 7 8 3 13Z"
      />
      <path
        fill="var(--hair)"
        d="M475 0c3 2 6 1 9 2 18 3 35 9 49 21l31 26a15 15 0 0 1 5 10c0 4 0 7-4 9-8 6-15 14-22 21-2 2-5 4-9 3-1-3 1-6 3-8s4-4 3-7-4-3-7-3c-6 0-12 2-18 1l-2 2c-5 6-11 8-18 7-4-4-2-9-1-14a16 16 0 0 0-1-12l-11-22c-5-8-12-13-18-19-7-6-7-11 2-16a6 6 0 0 0 1-1ZM563 270c0-3 2-4 4-4 4-1 6-3 8-6a190 190 0 0 0 18-27c2-3 4-7 8-7 5 0 7 5 9 8 1 2 1 6 3 8v10c-4 6-7 12-12 17l-1 5c0 6 1 12-1 18-3 9-9 12-17 8l-12-4-6-4c3-3 7-4 10-5 4-1 4-2 3-6-2-7-7-10-14-11Z"
      />
      <path
        d="M172 365c3-5 3-8-3-13-8-6-16-9-26-5l-1-1c4-7 5-16 10-22 2-1 2-3 2-5 1-3 1-7 4-9 7-4 7-11 8-18a54 54 0 0 1 5-15c2-4-2-8 1-11l3 2c4 6 10 7 15 6 11-2 22-4 33-8 5-2 7-5 7-11l-2-8c2-8-4-13-6-19-1-4-5-7-6-11 9-6 16-13 26-17 11-3 22-3 33-5 2 0 3 0 2 3-3 10-1 19 5 28h2c0 3-1 4-4 4a81 81 0 0 0-10 0c-3 0-4 2-2 4 7 4 9 14 19 14l1 2c4 7 12 8 19 9l6 1c4 4 9 1 13-1s7-3 12-3c4 8 2 14-3 20-2 2-4 5-4 8a59 59 0 0 1-2 12c-2 4-4 8-2 12 3 9 4 18 4 27 0 5 1 10 5 14-2 2-5 3-8 3-8 0-17 1-25-1-7-2-14 0-21 2-15 3-28 0-42-4-12-4-25-7-37-7-8 0-14 4-19 10a6 6 0 0 0-1 3c-1 8-3 9-11 10Z"
        fill="var(--shirt)"
      />
      <path
        fill="var(--flesh)"
        d="M284 226h-2c-6-9-8-18-5-28 1-3 0-3-2-3 15-1 28-7 40-15 9-7 21-8 31-11l53-14c10-3 19-9 29-13s21-8 32-9c6 0 10-3 14-8l12-18c4-7 8-14 9-23 7 1 13-1 18-7l2-2c6 1 12-1 18-1 3 0 5 0 7 3s-1 5-3 7-4 5-3 8a90 90 0 0 0-21 26l-15 29-19 32c-7 12-18 21-29 29-9 7-18 12-23 22-5 9-8 19-10 29l-7 16c-4-5-7-10-12-13-7-4-13-10-18-17-3-4-8-9-6-16 7-8 17-14 22-24a26 26 0 0 1 7-8l27-21c1-1 4-3 3-4-1-2-4-2-6-1-4 1-9 2-14 0-5-3-9-1-13 2-17 12-34 22-53 29l-39 16c-7 5-16 7-24 8Zm158-72a21 21 0 0 0-11 4 3 3 0 0 0-1 2c0 2 1 2 2 2a47 47 0 0 0 8 1c3-1 5-4 6-7s-3-2-4-2Z"
      />
      <path
        fill="var(--hair)"
        d="m166 257-19-10c-12-7-14-22-13-33 2-11 13-18 25-21 10-3 20-1 30 0a12 12 0 0 0 3 0c3-1 6-3 8 0a17 17 0 0 1 6 12v3c-3 8-10 12-18 14-6 1-11 4-12 10 0 6 5 8 9 10 4 1 4 3 2 5s-1 5 0 8c0 1 1 3-1 4-1 1-3 0-4-1-4-3-8-4-13-2a14 14 0 0 1-3 1Z"
      />
      <path
        fill="var(--flesh)"
        d="M166 257a14 14 0 0 0 3-1c5-2 9-1 13 2 1 1 3 2 4 1 2-1 1-3 1-4-2-3-1-5 0-8s2-4-2-5c-4-2-10-4-9-10s6-9 12-10c8-2 15-6 18-14l10 8a2 2 0 0 0 0 1c1 4 5 7 6 11 2 6 8 11 6 19l2 8c0 6-2 9-7 11-11 4-22 6-33 8-5 1-11 0-15-6l-3-2a4 4 0 0 0-2-3c-3-1-4-3-4-6Z"
      />
      <path
        d="M374 229c-2 7 3 12 6 16 5 7 11 13 18 17 5 3 8 8 12 13l7-16 10 1c3 1 6 2 7 5 0 6-2 12-5 18a8 8 0 0 0 0 7c3 6 3 9-4 12-2 2-2 3-1 5v2c-1 13-3 14-15 11l-7-1c-2-1-3 0-5 1-11 2-17 13-26 18-11 7-23 8-35 11-4-4-5-9-5-14 0-9-1-18-4-27-2-4 0-8 2-12a59 59 0 0 0 2-12c0-3 2-6 4-8 5-6 7-13 3-20 3 2 7 3 9-2h3c6 2 8-1 11-5l4-7c3-4 3-11 9-13Z"
        fill="var(--pants)"
      />
      <path
        fill="var(--flesh)"
        d="M424 307c-1-2-1-3 1-5 7-3 7-6 4-12a8 8 0 0 1 0-7c3-6 5-12 5-18 17 3 35 0 52 6h14c8-2 17-1 26 1 12 1 25 2 37-2 7 1 12 4 14 11 1 4 1 5-3 6-3 1-7 2-10 5-13 0-26 1-39 6s-27 6-41 3c-10-3-20-1-30 1a220 220 0 0 1-30 5Z"
      />
    </g>
  </g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>